import { z } from 'zod';
export const Frequency = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY',
    // Not used but needed for compatibility
    HOURLY: 'HOURLY',
    MINUTELY: 'MINUTELY',
    SECONDLY: 'SECONDLY',
};
export const WEEKDAYS = {
    MONDAY: 'MO',
    TUESDAY: 'TU',
    WEDNESDAY: 'WE',
    THURSDAY: 'TH',
    FRIDAY: 'FR',
    SATURDAY: 'SA',
    SUNDAY: 'SU',
};
export const rruleSchema = z.object({
    freq: z.enum([
        Frequency.DAILY,
        Frequency.WEEKLY,
        Frequency.MONTHLY,
        Frequency.YEARLY,
        // Not used but needed for compatibility
        Frequency.HOURLY,
        Frequency.MINUTELY,
        Frequency.SECONDLY,
    ]),
    dtstart: z.date().optional(),
    interval: z.number().min(1).optional(),
    count: z.number().min(1).optional(),
    until: z.string().optional(),
    tzid: z.string().optional(),
    bySetPos: z.array(z.number()).optional(),
    byMonth: z.array(z.number()).optional(),
    byMonthDay: z.array(z.number()).optional(),
    byYearDay: z.array(z.number()).optional(),
    byWeekNo: z.array(z.number()).optional(),
    byDay: z.array(z.enum(Object.values(WEEKDAYS))).optional(),
});
